<template>
  <el-dialog :visible.sync="dialogFormVisible" :title="titles[updateType]" :before-close="close">
    <el-form ref="form" label-width="120px" :model="initForm" :rules="rules">
      <el-form-item label="云平台" prop="cloud">
        <el-input v-model="initForm.cloud" placeholder="请输入云平台名称"></el-input>
      </el-form-item>

      <el-form-item label="备注" prop="desc">
        <el-input v-model="initForm.desc" placeholder="备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button @click="$emit('close')" type="info">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    initForm: {},
    updateType: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        cloud: [{required: true, message: "请输入云平台名称(英文简写)", trigger: "blur"}],
        desc: [{required: false, message: "请填写备注信息", trigger: "blur"}]
      },
      titles: {
        add: "新增",
        edit: "编辑"
      }
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        var method = "";
        var url = "";
        var msg = "操作失败";
        var formData = {
              cloud: this.initForm.cloud,
              desc: this.initForm.desc
            };
        if (!valid) {alert("请检查输入是否正确！"); return false;};
        this.dialogFormVisible = false;
        if (this.updateType === "add") {
          method = "post";
          url = "cloud/env/";
          msg = "添加成功";
        } else if (this.updateType === "edit") {
          method = "patch";
          url = "cloud/env/" + this.initForm.id + "/";
          msg = "编辑成功";
        } else{
          return false;
        };
        this.$http[method](
          url,
          formData,
          () => {
            this.$baseNotice.message(msg);
            this.$emit("close");
            this.$emit("update");
          }
        )
      });
    }
  }
};
</script>
